import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

const PurchaseConfirmModal = ({ open, item, onClose, onConfirm }) => (
    <Modal open={open} onClose={onClose}>
        <Paper
            sx={{
                padding: 3,
                maxWidth: 400,
                width: "90%",
                margin: "auto",
                mt: "20vh",
                backgroundColor: "background.paper",
                color: "text.primary",
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="h6">Подтверждение покупки</Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </Box>

            {item && (
                <Box>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        Вы уверены, что хотите купить <strong>{item.custom_name || item.name || `Предмет #${item.id}`}</strong> - <strong>{item.stock} шт.</strong> за <strong>{item.price} ₽</strong>?
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                        <Button variant="contained" color="primary" fullWidth onClick={onConfirm}>
                            Подтвердить
                        </Button>
                        <Button variant="outlined" fullWidth onClick={onClose}>
                            Отмена
                        </Button>
                    </Box>
                </Box>
            )}
        </Paper>
    </Modal>
);

export default PurchaseConfirmModal;
